import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { EmployeeDetailsModule } from './employee-details/employee-details.module';
import { EmployeeDetails } from './employee-details/employee-details.entity';
import { PassportModule } from './passport/passport.module'
import { AuthModule } from './auth/auth.module';
import { UserModule } from './user/user.module';
import { UserEntity } from './user/user.entity';
import { ScheduleModule } from '@nestjs/schedule';
import { LoggerModule, PinoLogger } from 'nestjs-pino';
import umsConfigs from '../../config';
import { QueryLogger } from '../../../logger/query-logger';
import {appSettings} from '../../../config';
import { EmployeeFamilyDetails } from './employee-details/employee-family-details.entity';
import { EmployeeIdProofDetails } from './employee-details/employee-id-proof-details.entity';
import { EmployeeExperienceDetails } from './employee-details/employee-experience-details.entity';
import { EmployeeEducationDetails } from './employee-details/employee-education-details.entity';
// import { TypeORMSession } from './auth/session';

@Module({
  imports: [
    LoggerModule.forRoot({ pinoHttp: { level: umsConfigs.loggingMode } }),
    PassportModule.register({session:true}),
    TypeOrmModule.forRoot({
      type: 'mysql',
      host: appSettings.dbhost,
      port: 3306,
      username: appSettings.dbuser,
      password: appSettings.dbpassword,
      database: appSettings.ums_db,
      entities: [UserEntity, EmployeeDetails,EmployeeFamilyDetails,EmployeeIdProofDetails,EmployeeExperienceDetails,EmployeeEducationDetails],
      synchronize: false,
      logging: false,
      // logger: new QueryLogger(new PinoLogger({ pinoHttp: { level: umsConfigs.loggingMode } })),
    }),
    ScheduleModule.forRoot(),
    AuthModule, UserModule, EmployeeDetailsModule],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule { }
